import React from 'react';
import { motion } from 'framer-motion';
export function FadeIn({
  children,
  delay = 0,
  className = '',
  duration = 1.2,
  y = 40
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  duration?: number;
  y?: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-10%'
  }} transition={{
    duration,
    delay,
    ease: [0.16, 1, 0.3, 1] // Custom long ease-out
  }} className={className} data-id="element-76">
      {children}
    </motion.div>;
}